import { computed, Directive, HostListener, inject, signal } from '@angular/core';
import { NgControl } from '@angular/forms';
import { PaymentCardType } from '../../interfaces/card.interface';

@Directive({
  selector: '[appPaymentCardNumberMask]',
  exportAs: 'paymentCardType',
  standalone: true,
})
export class PaymentCardNumberMaskDirective {
  private readonly control = inject(NgControl);

  public paymentCardType = signal<PaymentCardType>('unknown');
  private readonly rawValue = signal<string>('');

  public readonly cardType = computed<PaymentCardType>(() => {
    const val = this.rawValue();
    if (!val) {
      return 'unknown';
    }

    if (val.startsWith('4')) {
      return 'visa';
    }

    const firstTwo = parseInt(val.substring(0, 2), 10);
    const firstFour = parseInt(val.substring(0, 4), 10);

    if ((firstTwo >= 51 && firstTwo <= 55) || (firstFour >= 2221 && firstFour <= 2720)) {
      return 'mastercard';
    }

    return 'unknown';
  });

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const value = input.value.replace(/\D/g, '');
    const trimmed = value.substring(0, 16);

    this.rawValue.set(trimmed);

    const parts = trimmed.match(/.{1,4}/g);
    const formattedValue = parts ? parts.join(' ') : trimmed;

    input.value = formattedValue;

    this.control.control?.setValue(formattedValue, {
      emitEvent: false,
      emitModelToViewChange: false,
    });
  }
}
